import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const Container = styled.footer`
  padding: 10px 16px;
  text-align: center;
  border-top: 1px solid #E8ECF0;
  background: #fff;
  flex-shrink: 0;
`;

const Text = styled.p`
  font-size: ${({ theme }) => theme.metrics.font.size.xs};
  color: ${({ theme }) => theme.colors.text.dark.little};
`;

export default function Footer() {
  const { t } = useTranslation();

  return (
    <Container>
      <Text>{t('layout.copyright', { year: new Date().getFullYear() })}</Text>
    </Container>
  );
}
